import styled from 'styled-components';

export const StyledTitle = styled.h5`
  color: ${(props) => props.theme.white};
  font-size: 20px;
  font-weight: 600;
  margin: 10px 0px 20px 30px;
`;
